module.exports = __webpack_public_path__ + "img/img3.508ddc28.png";